/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileUpload} from 'primeng/fileupload';

@Component({
    selector: 'app-file-upload-card',
    templateUrl: './file-upload-card.component.html',
    standalone: false
})
export class FileUploadCardComponent implements OnInit {
  @Input() header = 'File Upload';
  @Input() subheader = 'Select one file';
  @Input() accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  @Output() filesSelected: EventEmitter<File[]> = new EventEmitter<File[]>();
  @ViewChild('fileUpload') fileUpload: FileUpload;
  placeholder = 'Drop file here';
  showCancelButton = false;
  chooseLabel = 'Select File';
  @Input() multiple = false;

  onFileSelect() {
    this.filesSelected.emit(this.fileUpload.files);
  }
  formatFileSize(size: number) {
    return Math.round(size / 1000);
  }

  ngOnInit(): void {
    if (this.multiple) {
      this.chooseLabel = 'Select Files';
      this.placeholder = 'Drop files here';
      this.showCancelButton = true;
    }
  }
}
